/**
 * User-facing Gantt keyboard shortcut reference.
 * Undo/Redo (Ctrl+Z / Ctrl+R) intentionally omitted until store-synced undo ships.
 */

export type GanttShortcutHelpRow = {
  keys: string;
  description: string;
};

export type GanttShortcutHelpSection = {
  title: string;
  rows: GanttShortcutHelpRow[];
};

export const GANTT_KEYBOARD_SHORTCUT_SECTIONS: GanttShortcutHelpSection[] = [
  {
    title: 'Tasks',
    rows: [
      { keys: '↑ ↓', description: 'Move to the previous or next task' },
      { keys: 'Page Up / Page Down', description: 'Jump to the first or last visible task' },
      { keys: '⇧ ↑ / ⇧ ↓', description: 'Collapse or expand a parent task' },
      { keys: 'Ctrl ← / Ctrl →', description: 'Collapse or expand a parent task' },
      { keys: '⇧ ← / ⇧ →', description: 'Outdent or indent the task' },
      { keys: 'Space', description: 'Select or unselect the focused task' },
      { keys: 'Enter', description: 'Open task details' },
      { keys: 'Ctrl Enter', description: 'Open Add task under the focused task' },
      { keys: 'Delete', description: 'Delete the focused task' },
    ],
  },
  {
    title: 'Chart',
    rows: [
      { keys: 'Alt ← → ↑ ↓', description: 'Scroll the timeline horizontally or vertically' },
    ],
  },
  {
    title: 'Grid header',
    rows: [
      { keys: '← →', description: 'Move between column headers' },
      { keys: '↓', description: 'Move focus into the first task row' },
      { keys: 'Enter / Space', description: 'Activate the focused header control' },
    ],
  },
  {
    title: 'App',
    rows: [
      { keys: '⌘ / Ctrl F', description: 'Focus the task name search field' },
      { keys: 'Esc', description: 'Cancel an inline date edit without saving' },
    ],
  },
];
